import React, { useState } from "react";
import { Button } from "react-bootstrap";
import ProductsLearnMoreModal from "./ProductsLearnMoreModal";

export default function ProductsBoomAI() {
  const [selectedProduct, setSelectedProduct] = useState(null);

  const handleLearnMoreClick = (event, product) => {
    event.preventDefault();
    event.stopPropagation();
    setSelectedProduct(product);
  };

  const handleCloseModal = () => {
    setSelectedProduct(null);
  };

  return (
    <div className="bg-page rounded-4 p-3 mb-5">
      <div className="text-center mb-4">
        <img
          src="/assets/products/images/ai.png"
          alt="BoomAI"
          className="img-fluid rounded-4"
          style={{ maxHeight: "280px", objectFit: "cover" }}
        />
        <div className="fw-bold text-navy text-center fs-2 mt-3">BoomAI</div>
      </div>

      <div>
        <p className="fs-5 mt-3">
          BoomAI is Boomerang’s intelligent layer for turning communication into
          action.
        </p>
        <p className="fs-5 ">
          It brings artificial intelligence directly into your messaging
          workflows, enabling organisations to automate decisions, personalise
          engagement at scale, and respond to events in real time.
        </p>
        <p className="fs-5 ">
          At its core, BoomAI analyses incoming and outgoing data across your
          communication channels, SMS, email, voice, WhatsApp and more, to
          understand intent, context and behaviour. This allows you to move
          beyond static messaging and into dynamic, adaptive conversations that
          evolve based on user responses and external data inputs.
        </p>
        <p className="fs-5 ">
          Whether you’re handling customer enquiries, triggering alerts, or
          managing operational workflows, BoomAI can classify messages, extract
          key information, and determine the next best action instantly. This
          reduces manual intervention, speeds up response times, and ensures
          consistent, intelligent outcomes across every interaction.
        </p>
        <p className="fs-5 ">
          BoomAI integrates seamlessly with Boomerang’s Logic platform, meaning
          AI-driven decisions can directly influence workflows, routing,
          escalation and messaging. It also connects to your wider systems via
          APIs, allowing data to flow freely between applications and ensuring
          decisions are always based on the most up-to-date information.
        </p>
        <p className="fs-5 ">
          Designed for flexibility, BoomAI can be applied across a wide range of
          use cases, from customer service automation and campaign optimisation
          to risk detection and operational monitoring.
        </p>
        <p className="fs-5 ">
          The result is simple: smarter communication, faster decisions, and the
          ability to scale personalised, intelligent engagement without
          increasing complexity or overhead.
        </p>
      </div>

      <div className="text-center d-flex justify-content-center gap-3 mt-4">
        <Button
          className="bg-colored-reverse fw-bold border-0 rounded-3"
          onClick={(event) => handleLearnMoreClick(event, { name: "trial" })}
        >
          Free trial
        </Button>
        <Button
          className="bg-colored-reverse fw-bold border-0 rounded-3"
          onClick={(event) => handleLearnMoreClick(event, { name: "buy" })}
        >
          Buy
        </Button>
        <Button
          className="bg-colored-reverse fw-bold border-0 rounded-3"
          onClick={(event) =>
            handleLearnMoreClick(event, { name: "more information" })
          }
        >
          More Information
        </Button>
        <ProductsLearnMoreModal
          selectedProduct={selectedProduct}
          handleCloseModal={handleCloseModal}
        />
      </div>
    </div>
  );
}
